import { createContext } from 'react'
import { StoreApi } from 'zustand'
import { Session } from 'next-auth'
import { IHIVerificationState } from '@/shared/components/hi/HealthcareIdentifierForm'
import { ProfileStatus } from '@/lib/apis/types'

interface IHIVerifyFormState {
  session: Session | null
  ihiVerificationState: IHIVerificationState
  updateIHIVerificationState: (state: IHIVerificationState) => void
  completeVerifiedIdentifierAttachment: (
    profileStatus: ProfileStatus | null,
  ) => void

  onNext: () => void
  onPrev: () => void
}

type IHIVerifyFormStore = StoreApi<IHIVerifyFormState>
export const IHIVerifyFormContext = createContext<IHIVerifyFormStore | null>(
  null,
)
